﻿export enum RioPermissionFlags {
    None = 0,
    Read = 1,
    Edit = 2,
    Add = 4,
    Delete = 8
}